import * as formWizardConstants from './constants';
import getActivePanel from './getActivePanel';

/**
 * Gets all fields in the active panel of a form
 *
 * @param {Element} form
 */
export default function getVisibleFields(form) {
  if (!form) return [];
  const activePanel = getActivePanel(form);
  if (!activePanel) return [];

  return [
    ...activePanel.querySelectorAll(
      formWizardConstants.selectors.fields.join(',')
    )
  ];
}
